import { render } from "./ChatSearch.vue?vue&type=template&id=3bb28b61&scoped=true"
import script from "./ChatSearch.vue?vue&type=script&lang=js"
export * from "./ChatSearch.vue?vue&type=script&lang=js"

import "./ChatSearch.vue?vue&type=style&index=0&id=3bb28b61&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb28b61"]])

export default __exports__